/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUserChoices = /* GraphQL */ `
  mutation CreateUserChoices(
    $input: CreateUserChoicesInput!
    $condition: ModelUserChoicesConditionInput
  ) {
    createUserChoices(input: $input, condition: $condition) {
      id
      response {
        challengeId
        steps
        correct
      }
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const updateUserChoices = /* GraphQL */ `
  mutation UpdateUserChoices(
    $input: UpdateUserChoicesInput!
    $condition: ModelUserChoicesConditionInput
  ) {
    updateUserChoices(input: $input, condition: $condition) {
      id
      response {
        challengeId
        steps
        correct
      }
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserChoices = /* GraphQL */ `
  mutation DeleteUserChoices(
    $input: DeleteUserChoicesInput!
    $condition: ModelUserChoicesConditionInput
  ) {
    deleteUserChoices(input: $input, condition: $condition) {
      id
      response {
        challengeId
        steps
        correct
      }
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const createMasterData = /* GraphQL */ `
  mutation CreateMasterData(
    $input: CreateMasterDataInput!
    $condition: ModelMasterDataConditionInput
  ) {
    createMasterData(input: $input, condition: $condition) {
      id
      title
      description
      steps {
        sid
        explanation
        seq
        description
      }
      recommendations
      order
      hint
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const updateMasterData = /* GraphQL */ `
  mutation UpdateMasterData(
    $input: UpdateMasterDataInput!
    $condition: ModelMasterDataConditionInput
  ) {
    updateMasterData(input: $input, condition: $condition) {
      id
      title
      description
      steps {
        sid
        explanation
        seq
        description
      }
      recommendations
      order
      hint
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteMasterData = /* GraphQL */ `
  mutation DeleteMasterData(
    $input: DeleteMasterDataInput!
    $condition: ModelMasterDataConditionInput
  ) {
    deleteMasterData(input: $input, condition: $condition) {
      id
      title
      description
      steps {
        sid
        explanation
        seq
        description
      }
      recommendations
      order
      hint
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
